export default __webpack_public_path__ + "static/bg_slotxo-6805e591a99a0ab46501ff005569ed85.png";